var supportDescriptors = require('core-js/internals/descriptors');
var defineProperty = require('core-js/internals/object-define-property').f;
var NAME = 'remove';

// https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove#Polyfill
if (supportDescriptors) {
  // Objects types that implement ChildNode interface
  var protos = [Element.prototype, CharacterData.prototype, DocumentType.prototype];
  for (var i = 0; i < protos.length; i++) {
    var proto = protos[i];

    if (proto.hasOwnProperty(NAME)) {
      continue;
    }

    defineProperty(proto, NAME, {
      configurable: true,
      value: function () {
        if(this.parentNode){
          this.parentNode.removeChild(this);
        }
      }
    });
  }
}
